const ReportTypes = {
  GET_SUMMARY_REPORT_REQUEST: 'GET_SUMMARY_REPORT_REQUEST',
  GET_SUMMARY_REPORT_SUCCESS: 'GET_SUMMARY_REPORT_SUCCESS',
  GET_SUMMARY_REPORT_ERROR: 'GET_SUMMARY_REPORT_ERROR',

  GET_AGEING_REPORT_REQUEST: 'GET_AGEING_REPORT_REQUEST',
  GET_AGEING_REPORT_SUCCESS: 'GET_AGEING_REPORT_SUCCESS',
  GET_AGEING_REPORT_ERROR: 'GET_AGEING_REPORT_ERROR',

  GET_REPORT_FILTER_REQUEST: 'GET_REPORT_FILTER_REQUEST',
  GET_REPORT_FILTER_SUCCESS: 'GET_REPORT_FILTER_SUCCESS',
  GET_REPORT_FILTER_ERROR: 'GET_REPORT_FILTER_ERROR',

  CLIENT_BASED_REPORT_REQUEST: 'CLIENT_BASED_REPORT_REQUEST',
  CLIENT_BASED_REPORT_SUCCESS: 'CLIENT_BASED_REPORT_SUCCESS',
  CLIENT_BASED_REPORT_ERROR: 'CLIENT_BASED_REPORT_ERROR',

  DEPARTMENT_BASED_REPORT_REQUEST: 'DEPARTMENT_BASED_REPORT_REQUEST',
  DEPARTMENT_BASED_REPORT_SUCCESS: 'DEPARTMENT_BASED_REPORT_SUCCESS',
  DEPARTMENT_BASED_REPORT_ERROR: 'DEPARTMENT_BASED_REPORT_ERROR',

  GET_SUMMARY_REPORT_FILTER_REQUEST: 'GET_SUMMARY_REPORT_FILTER_REQUEST',
  GET_SUMMARY_REPORT_FILTER_SUCCESS: 'GET_SUMMARY_REPORT_FILTER_SUCCESS',
  GET_SUMMARY_REPORT_FILTER_ERROR: 'GET_SUMMARY_REPORT_FILTER_ERROR',

  GET_AGEING_REPORT_FILTER_REQUEST: 'GET_AGEING_REPORT_FILTER_REQUEST',
  GET_AGEING_REPORT_FILTER_SUCCESS: 'GET_AGEING_REPORT_FILTER_SUCCESS',
  GET_AGEING_REPORT_FILTER_ERROR: 'GET_AGEING_REPORT_FILTER_ERROR'
};
export default ReportTypes;
